import isEmail from 'validator/lib/isEmail'
import isURL from 'validator/lib/isURL'

/**
 * Validates any value as a url
 *
 * Return Validation Result:
 * {
 * valid: Boolean,
 * error: String | null
 * }
 * @param {*} valueToValidate Value to determine if exists
 * @returns {object} Validation Result
 */
const TEL_PATTERN = /^tel:\+?[0-9\-().]+$/

const url = (valueToValidate) => {
  const validResponse = {
    errors: [],
    valid: true,
  }

  if (!valueToValidate) {
    return validResponse
  }

  if (valueToValidate.startsWith('mailto:')) {
    const email = valueToValidate.slice('mailto:'.length)
    if (email && isEmail(email)) {
      return validResponse
    }
    return {
      errors: ['Must be a valid email address'],
      valid: false,
    }
  }

  if (valueToValidate.startsWith('tel:')) {
    if (TEL_PATTERN.test(valueToValidate)) {
      return validResponse
    }
    return {
      errors: ['Must be a valid phone number'],
      valid: false,
    }
  }

  if (!isURL(valueToValidate)) {
    return {
      errors: ['Must be URL'],
      valid: false,
    }
  }

  if (
    !isURL(valueToValidate, {
      protocols: ['https'],
      require_protocol: true,
      require_valid_protocol: true,
    })
  ) {
    return {
      errors: ['URL must start with https://'],
      valid: false,
    }
  }

  return validResponse
}

export { url }
